import { createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-44cadcc0")
const _hoisted_1 = /*#__PURE__*/_createElementVNode("button", {
  id: "button-dashboard-options-restore-modal",
  type: "button",
  class: "d-none",
  "data-bs-toggle": "modal",
  "data-bs-target": "#dashboardOptionsRestoreModal"
}, null, -1)
const _hoisted_2 = {
  class: "modal fade",
  id: "dashboardOptionsRestoreModal",
  "data-bs-keyboard": "true",
  tabindex: "-1",
  "aria-labelledby": "dashboardOptionsRestoreModalLabel",
  "aria-hidden": "true"
}
const _hoisted_3 = { class: "modal-dialog modal-dialog-centered max-w-max-con" }
const _hoisted_4 = { class: "modal-content" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "modal-title  d-flex flex-column",
    id: "dashboardOptionsRestoreModalLabel"
  }, [
    /*#__PURE__*/_createElementVNode("h5", null, " Are You sure you want to Restore Dashboard Options? "),
    /*#__PURE__*/_createElementVNode("h5", null, " This action cannot be undone. ")
  ]),
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn-close ms-2 d-block",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  })
], -1)
const _hoisted_6 = { class: "modal-footer restore-modal-responsive-flex" }
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("button", {
              type: "button",
              class: "btn mo-btn-warning",
              "data-bs-dismiss": "modal",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.restoreOptions())),
              style: {"order":"1"}
            }, " Proceed To Restore Dashboard Options To Default ")
          ])
        ])
      ])
    ])
  ], 64))
}